import Swal, { SweetAlertOptions } from "sweetalert2";
import { i18n } from "@/i18n";

export const popup = async (event: SweetAlertOptions | string) => {
  if (typeof event === "string") {
    await Swal.fire({
      html: event,
      icon: "warning",
      confirmButtonColor: "var(--warning)",
      confirmButtonText: i18n.global.t("buttons.defaultConfirm"),
      customClass: {
        htmlContainer: "swal-custom-text",
      },
    });
  } else {
    if (!event.confirmButtonText) {
      event.confirmButtonText = i18n.global.t("buttons.defaultConfirm");
    }
    if (!event.confirmButtonColor) {
      event.confirmButtonColor = "var(--in-progress)";
    }
    // callback 억지로 - 파라마터 더 안 늘리기 위해서 강제로 끼워넣음
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const callback = event.callback;

    const ev = {
      icon: "warning",
      confirmButtonColor: "var(--warning)",
      confirmButtonText: i18n.global.t("buttons.defaultConfirm"),
      ...event,
    } as SweetAlertOptions;
    delete ev["callback"];

    const res = await Swal.fire(ev);
    if (!res.isConfirmed) {
      return;
    }

    if (callback) {
      callback();
    }
  }
};
